import { useCheckList } from "./CheckListContext"

const ButtonBar = ({rec}) => {
    const {moveUp, moveDown} = useCheckList()
    const upHandler = () => {
        // console.log("moveup", rec._ctx)
        moveUp(rec._ctx.prevBlock, rec._ctx)
    }
    const downHandler = () => {
        // console.log("movedown", rec._ctx)
        moveDown(rec._ctx, rec._ctx.nextBlock)
    }

    return (
        <span>
            <button
                type="button"
                className="swap-btn"
                disabled={!rec._ctx.prevBlock}
                onClick={() => upHandler()}
            >
                ↑
            </button>
            <button
                type="button"
                className="swap-btn"
                disabled={!rec._ctx.nextBlock}
                onClick={() => downHandler()}
            >
                ↓
            </button>
        </span>
    )
}

export default ButtonBar